<template>
    <validation-observer v-slot="{ handleSubmit }" ref="formHandler">
        <form class="form" @submit.prevent="handleSubmit(formRestrictions)" novalidate>
            <div class="form-title tw-text-center tw-flex tw-flex-col tw-items-center tw-justify-center tw-font-bold tw-relative tw-leading-none tw-pt-5 lg:tw-py-5" v-if="step !== 3">
                Simule agora a sua<br class="tw-hidden lg:tw-block"> Poupança
                <img src="~@/assets/img/icons/triangle.svg">
            </div>
            <fieldset class="tw-px-8 tw-pb-3 lg:tw-px-12 xl:tw-px-16 lg:tw-pb-6 tw-pt-3 lg:tw-pt-6">
                <div class="step" v-if="step === 1">
                    <div class="range-container tw-pb-8">
                        <p class="range-title tw-text-white tw-font-semibold">Valor Total dos Créditos<br><span class="tw-font-normal">(excepto crédito habitação)</span></p>
                        <div class="tw-hidden lg:tw-flex tw-items-center tw-justify-between tw-gap-2">
                            <div class="range-slider">
                                <range-slider
                                    class="slider"
                                    min="5000"
                                    max="300000"
                                    step="1000"
                                    v-model="amount">
                                </range-slider>
                            </div>
                            <validation-provider class="tw-w-full tw-w-block" name="amount" rules="required|between:5000,300000" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', amount: ' ' }">
                                <div class="input-group input-group-amount" :class="classes">
                                    <input type="tel"
                                        id="input-amount"
                                        placeholder=" "
                                        v-model="amount"
                                        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                                        class="step-1"
                                    >
                                    <label>
                                        Ex. 150000€
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                        <div class="tw-block lg:tw-hidden">
                            <validation-provider class="tw-w-full tw-w-block" name="amount" rules="required|between:5000,300000" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', amount: ' ' }">
                                <div class="input-group input-group-amount" :class="classes">
                                    <input type="tel"
                                        id="input-amount"
                                        placeholder=" "
                                        v-model="amount"
                                        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                                        class="step-1"
                                    >
                                    <label>
                                        Ex. 150000€
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                    </div>
                    <div class="range-container tw-pb-8">
                        <p class="range-title tw-text-white tw-font-semibold">Rendimento liquido mensal<br>do agregado familiar</p>
                        <div class="tw-hidden lg:tw-flex tw-items-center tw-justify-between tw-gap-2">
                            <div class="range-slider">
                                <range-slider
                                    class="slider"
                                    min="100"
                                    max="5000"
                                    step="50"
                                    v-model="income">
                                </range-slider>
                            </div>
                            <validation-provider class="tw-w-full tw-w-block" name="income" rules="required|between:100,5000" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', income: ' ' }">
                                <div class="input-group input-group-income" :class="classes">
                                    <input type="tel"
                                        id="input-income"
                                        placeholder=" "
                                        v-model="income"
                                        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                                        class="step-1"
                                    >
                                    <label>
                                        Ex. 1650€
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                        <div class="tw-block lg:tw-hidden">
                            <validation-provider class="tw-w-full tw-w-block" name="income" rules="required|between:100,5000" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', income: ' ' }">
                                <div class="input-group input-group-income" :class="classes">
                                    <input type="tel"
                                        id="input-income"
                                        placeholder=" "
                                        v-model="income"
                                        oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1');"
                                        class="step-1"
                                    >
                                    <label>
                                        Ex. 1650€
                                    </label>
                                </div>
                            </validation-provider>
                        </div>
                    </div>
                    <p class="range-title tw-text-white tw-font-semibold tw-text-center">Tem 2 ou mais empréstimos?</p>
                    <validation-provider class="tw-w-full tw-w-block" name="credits" rules="required" v-slot="{ classes }">
                        <div class="input-group-credits form-check tw-grid tw-grid-cols-2 tw-gap-5 tw-py-6">
                            <label class="form-check-label tw-relative" :class="classes">
                                <input class="form-check-input" type="radio" value="1" v-model="credits">
                                <span class="checkmark">Sim</span>
                            </label>
                            <label class="form-check-label tw-relative" :class="classes">
                                <input class="form-check-input tw-hidden" type="radio" value="0" v-model="credits">
                                <span class="checkmark">Não</span>
                            </label>
                        </div>
                    </validation-provider>
                    <button class="btn-cta tw-mt-1 lg:tw-mt-10 tw-mx-auto tw-block" @click.prevent="firstStepCheck">Simule Grátis</button>
                </div>
                <div class="step" v-if="step === 2">
                    <div class="range-container tw-pb-8">
                        <p class="range-title tw-text-white tw-font-semibold">Tem atrasos de pagamento nas prestações?</p>
                        <validation-provider class="tw-w-full tw-pb-2" name="hasDelay" rules="required" v-slot="{ classes }">
                            <div class="input-group-hasDelay form-check tw-grid tw-grid-cols-2 tw-gap-5 tw-py-6">
                                <label class="form-check-label tw-relative" :class="classes">
                                    <input class="form-check-input" type="radio" value="sim" v-model="hasDelay">
                                    <span class="checkmark">Sim</span>
                                </label>
                                <label class="form-check-label tw-relative" :class="classes">
                                    <input class="form-check-input tw-hidden" type="radio" value="nao" v-model="hasDelay">
                                    <span class="checkmark">Não</span>
                                </label>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="range-container tw-pb-8">
                        <p class="range-title tw-text-white tw-font-semibold">Algum titular com contrato de trabalho efetivo?</p>
                        <validation-provider class="tw-w-full tw-pb-2" name="workContract" rules="required" v-slot="{ classes }">
                            <div class="input-group-workContract form-check tw-grid tw-grid-cols-2 tw-gap-5 tw-py-6">
                                <label class="form-check-label tw-relative" :class="classes">
                                    <input class="form-check-input" type="radio" value="sim" v-model="workContract">
                                    <span class="checkmark">Sim</span>
                                </label>
                                <label class="form-check-label tw-relative" :class="classes">
                                    <input class="form-check-input tw-hidden" type="radio" value="nao" v-model="workContract">
                                    <span class="checkmark">Não</span>
                                </label>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="range-container tw-pb-2">
                        <p class="range-title tw-text-white tw-font-semibold">Tem residência temporária em Portugal?</p>
                        <validation-provider class="tw-w-full tw-pb-2" name="temporaryResidence" rules="required" v-slot="{ classes }">
                            <div class="input-group-temporaryResidence form-check tw-grid tw-grid-cols-2 tw-gap-5 tw-py-6">
                                <label class="form-check-label tw-relative" :class="classes">
                                    <input class="form-check-input" type="radio" value="sim" v-model="temporaryResidence">
                                    <span class="checkmark">Sim</span>
                                </label>
                                <label class="form-check-label tw-relative" :class="classes">
                                    <input class="form-check-input tw-hidden" type="radio" value="nao" v-model="temporaryResidence">
                                    <span class="checkmark">Não</span>
                                </label>
                            </div>
                        </validation-provider>
                    </div>
                    <div class="range-container tw-pb-2">
                        <p class="range-title tw-text-white tw-font-semibold">Incluir um segundo titular?<br><span>Sabia que ao incluir um segundo titular existe maior probabilidade do seu crédito ser aprovado?</span></p>
                        <validation-provider class="tw-w-full tw-pb-2" name="secondPerson" rules="required" v-slot="{ classes }">
                            <div class="input-group-secondPerson form-check tw-grid tw-grid-cols-2 tw-gap-5 tw-py-6">
                                <label class="form-check-label tw-relative" :class="classes">
                                    <input class="form-check-input" type="radio" value="sim" v-model="secondPerson">
                                    <span class="checkmark">Sim</span>
                                </label>
                                <label class="form-check-label tw-relative" :class="classes">
                                    <input class="form-check-input tw-hidden" type="radio" value="nao" v-model="secondPerson">
                                    <span class="checkmark">Não</span>
                                </label>
                            </div>
                        </validation-provider>
                    </div>
                    <button class="btn-cta tw-mt-1 lg:tw-mt-10 tw-mx-auto tw-block" @click.prevent="secondStepCheck">Continuar</button>
                </div>
                <div class="step tw-pt-4 lg:tw-pt-8" v-if="step === 3">
                    <validation-provider class="tw-w-full tw-w-block" name="fullName" rules="required|alpha_spaces" v-slot="{ classes }">
                        <div class="input-group input-group-name" :class="classes">
                            <input type="text"
                                id="input-fullName"
                                placeholder=" "
                                v-model="fullName"
                            >
                            <label>
                                Nome completo
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="birthdate" rules="required" v-slot="{ classes }">
                        <div class="input-group input-group-birthdate" :class="classes">
                            <input type="text"
                                id="input-birthdate"
                                placeholder=" "
                                v-model="birthdate"
                                v-mask="{alias: 'datetime', inputFormat: 'dd/mm/yyyy', placeholder: 'DD/MM/AAAA', showMaskOnHover: false, showMaskOnFocus: true}"
                            >
                            <label>
                                Data de nascimento
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="email" rules="required|email" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', email: 'inválido' }">
                        <div class="input-group input-group-email" :class="classes">
                            <input type="email"
                                id="input-email"
                                placeholder=" "
                                v-model.lazy="email"
                            >
                            <label>
                                Email {{ errors [0]}}
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="phone" rules="required|phone:pt" v-slot="{ classes, errors }" :custom-messages="{ required: ' ', phone: ' ' }">
                        <div class="input-group input-group-phone" :class="classes">
                            <input type="tel"
                                id="input-phone"
                                placeholder=" "
                                v-model="phone"
                                v-mask="{mask: '999999999', placeholder: ' '}"
                            >
                            <label>
                                Telemóvel {{ errors [0]}}
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="maritalStatus" rules="required" v-slot="{ classes }">
                        <div class="input-group input-group-name" :class="classes">
                            <select id="input-maritalStatus" placeholder=" " v-model="maritalStatus">
                                <option value="" selected disabled></option>
                                <option value="solteiro">Solteiro/a</option>
                                <option value="casado">Casado/a</option>
                                <option value="divorciado">Divorciado/a</option>
                                <option value="viuvo">Viuvo/a</option>
                                <option value="uniao_de_facto">União de Facto</option>
                                <option value="separado_de_facto">Separado de Facto</option>
                            </select>
                            <label :class="{ 'select-placeholder' : !maritalStatus }">
                                Estado Civil
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="city" rules="required" v-slot="{ classes }">
                        <div class="input-group input-group-city" :class="classes">
                            <input type="text"
                                id="input-city"
                                placeholder=" "
                                v-model="city"
                            >
                            <label>
                                Localidade
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" name="housing" rules="required" v-slot="{ classes }">
                        <div class="input-group input-group-name" :class="classes">
                            <select id="input-maritalStatus" placeholder=" " v-model="housing">
                                <option value="" selected disabled></option>
                                <option value="proprietario">Própria</option>
                                <option value="locatario">Arrendada</option>
                                <option value="de_familiares">De familiares</option>
                                <option value="prop_cred_habita">Própria c/ Créd. Habitação</option>
                            </select>
                            <label :class="{ 'select-placeholder' : !housing }">
                                Tipo de Habitação
                            </label>
                        </div>
                    </validation-provider>
                    <validation-provider class="tw-w-full tw-w-block" :rules="{required : { allowFalse: false } }" v-slot="{ classes }">
                        <div class="mb-2">
                            <div class="form-check p-0">
                                <label class="form-check-label" :class="classes">
                                    <input class="form-check-input" type="checkbox" value="true" v-model="$store.state.privacyPolicy">
                                    <span class="checkmark"></span>
                                    <span class="tw-text-white">Autorizo a {{ company }} a utilizar os meus dados para ser contactado segundo a sua <a href="#" @click.prevent="$store.state.modal.terms = true"><u>política de privacidade</u></a>.</span>
                                </label>
                            </div>
                        </div>
                    </validation-provider>
                    <div class="tw-text-center tw-block tw-mt-3 lg:tw-mt-16">
                        <button
                            type="submit"
                            class="btn-cta tw-block tw-mx-auto"
                            id="submit"
                            :disabled="formLoading"
                            @click="formRestrictions"
                        >
                            ENVIAR
                        </button>
                    </div>
                </div>
            </fieldset>
            <div class="steps tw-flex tw-justify-center tw-items-center tw-mt-2 tw-pb-6 tw-gap-2">
                <div :class="{ 'active' : step >= 1 }" />
                <div :class="{ 'active' : step >= 2 }" />
                <div :class="{ 'active' : step >= 3 }" />
            </div>
        </form>
    </validation-observer>
</template>

<script>
import RangeSlider from 'vue-range-slider';
import 'vue-range-slider/dist/vue-range-slider.css';
import axios from 'axios';
// Check validations folder for more validations
import '@/validations';
import '@/validations/phone';

export default {
    name: 'FormComponent',
    data() {
        return {
            fullName: '',
            birthdate: '',
            phone: '',
            email: '',
            maritalStatus: '',
            city: '',
            temporaryResidence: '',
            housing: '',
            comment: '',
            months: '',
            amount: 150000,
            income: 2200,
            credits: null,
            extraMoney: 'sim', // not present in form
            hasDelay: '',
            workContract: '',
            secondPerson: '',

            labelMessage: 'Ex: 2',
            step: 1,
            formLoading: false,
            usedClasses: ['.has-error'],
            company: process.env.VUE_APP_COMPANY,
        };
    },
    components: {
        RangeSlider,
    },
    methods: {
        firstStepCheck() {

            document.querySelector('.input-group-credits').parentNode.classList.remove('has-error');
            document.querySelector('.input-group-income').parentNode.classList.remove('has-error');
            document.querySelector('.input-group-amount').parentNode.classList.remove('has-error');

            if (!this.credits || this.credits == null) {
                document.querySelector('.input-group-credits').parentNode.classList.add('has-error');
                return false;
            }

            if (this.amount > 300000 || this.amount < 5000) {
                document.querySelector('.input-group-amount').parentNode.classList.add('has-error');
                return false;
            }

            if (this.income < 100 || this.income > 5000) {
                document.querySelector('.input-group-income').parentNode.classList.add('has-error');
                return false;
            }

            this.step++;
        },
        secondStepCheck() {

            document.querySelector('.input-group-hasDelay').parentNode.classList.remove('has-error');
            document.querySelector('.input-group-workContract').parentNode.classList.remove('has-error');
            document.querySelector('.input-group-temporaryResidence').parentNode.classList.remove('has-error');
            document.querySelector('.input-group-secondPerson').parentNode.classList.remove('has-error');

            if (
                (!this.hasDelay || this.hasDelay == '') &&
                (!this.workContract || this.workContract == '') &&
                (!this.temporaryResidence || this.temporaryResidence == '') &&
                (!this.secondPerson || this.secondPerson == '')
            ) {
                document.querySelector('.input-group-hasDelay').parentNode.classList.add('has-error');
                document.querySelector('.input-group-workContract').parentNode.classList.add('has-error');
                document.querySelector('.input-group-temporaryResidence').parentNode.classList.add('has-error');
                document.querySelector('.input-group-secondPerson').parentNode.classList.add('has-error');
                return false;
            } else {

                if (!this.hasDelay || this.hasDelay == '') {
                    document.querySelector('.input-group-hasDelay').parentNode.classList.add('has-error');
                    return false;
                } else {
                    document.querySelector('.input-group-hasDelay').parentNode.classList.remove('has-error');
                }

                if (!this.workContract || this.workContract == '') {
                    document.querySelector('.input-group-workContract').parentNode.classList.add('has-error');
                    return false;
                } else {
                    document.querySelector('.input-group-workContract').parentNode.classList.remove('has-error');
                }

                if (!this.temporaryResidence || this.temporaryResidence == '') {
                    document.querySelector('.input-group-temporaryResidence').parentNode.classList.add('has-error');
                    return false;
                } else {
                    document.querySelector('.input-group-temporaryResidence').parentNode.classList.remove('has-error');
                }

                if (!this.secondPerson || this.secondPerson == '') {
                    document.querySelector('.input-group-secondPerson').parentNode.classList.add('has-error');
                    return false;
                } else {
                    document.querySelector('.input-group-secondPerson').parentNode.classList.remove('has-error');
                }
            }

            this.step++;
        },
        formRestrictions() {
            let birthYear = this.birthdate.split('/').pop(),
                currentYear = new Date().getFullYear();

            const reg = new RegExp('^[0-9/]*$');

            if (!(reg.test(this.birthdate) === false)) {
                if ((birthYear < 1900) || (currentYear - birthYear < 26) || (currentYear - birthYear > 65)) {
                    document.querySelector('#input-birthdate').parentNode.classList.add('has-error');
                    return false;
                } else {
                    document.querySelector('#input-birthdate').parentNode.classList.remove('has-error');

                    if(!this.$store.state.privacyPolicy || this.$store.state.privacyPolicy == false) {
                        return false;
                    }

                    if( ((this.credits == 0)) ||
                        ((this.maritalStatus == 'solteiro' || this.maritalStatus == 'divorciado' || this.maritalStatus == 'separado_de_facto' || this.maritalStatus == 'viuvo') && (this.income < 900)) ||
                        ((this.maritalStatus == 'casado' || this.maritalStatus == 'uniao_de_facto') && (this.income < 1500)) || (this.hasDelay == 'sim') || ((this.workContract == 'nao'))
                    ) {
                        this.$store.state.formError = true;
                        return false;
                    } else {
                        this.formSubmit();
                    }
                }
            } else {
                document.querySelector('#input-birthdate').parentNode.classList.add('has-error');
                return false;
            }
        },
        formSubmit() {
            this.formLoading = true;

            let cmpInfo = {
                vendor:{
                    consents: [],
                },
                tcString: '',
            };

            try{
                cmpInfo = __tcfapi('getTCData');
            } catch (e) {
                console.log('No CMP Info');
            }

            const action = `${process.env.VUE_APP_BACKOFFICE_ENDPOINT}/api/${process.env.VUE_APP_BACKOFFICE_SLUG}`;
            const data = {
                cible: this.$route.query.cible,
                pubid: this.$route.query.pubid,
                utm_source: this.$route.query.utm_source,
                utm_campaign: this.$route.query.utm_campaign,
                utm_medium: this.$route.query.utm_medium,
                utm_content: this.$route.query.utm_content,
                utm_term: this.$route.query.utm_term,
                token: this.$store.state.token,
                mclic: process.env.VUE_APP_MCLIC,

                fullName: this.fullName,
                birthdate: this.birthdate,
                phone: this.phone,
                email: this.email,
                maritalStatus: this.maritalStatus,
                city: this.city,
                temporaryResidence: this.temporaryResidence,
                housing: this.housing,
                comment: this.comment,
                months: this.months,
                amount: this.amount,
                income: this.income,
                credits: this.credits,
                extraMoney: this.extraMoney,
                hasDelay: this.hasDelay,
                workContract: this.workContract,
                secondPerson: this.secondPerson,

                consent: cmpInfo.vendor.consents.hasOwnProperty('702'),
                tcString: cmpInfo.tcString,
            };

            axios.post(action, data)
                .then((response) => {
                    this.$store.state.formSuccess = true;
                    this.$store.state.argann = response.data.argann;
                    this.$store.state.altid = response.data.altid;
                })
                .catch((error) => {
                    this.formLoading = false;
                    if (error.response.data.errors.email) {
                        error.response.data.errors.email = 'já registado';
                    }
                    if (error.response.data.errors.phone) {
                        error.response.data.errors.phone = 'já registado';
                    }
                    console.log(error.response.data.errors);
                    this.$refs.formHandler.setErrors(error.response.data.errors);
                });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/scss/partials/_variables.scss';
</style>
